import React from 'react';

import {
  richTextHasContent,
  Metadata,
  HelpBox,
} from '@italia/components/ItaliaTheme/View';

const FarmaciaMoreInfos = ({ content }) => {
  return (
    <Metadata content={content}>
      {/* HELP BOX - ULTERIORI INFORMAZIONI */}
      {richTextHasContent(content?.ulteriori_informazioni) && (
        <HelpBox text={content?.ulteriori_informazioni} />
      )}
    </Metadata>
  );
};

export default FarmaciaMoreInfos;
